import styled from '@emotion/styled'
import { Container, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import { Heading } from '../../../../Components/Heading'
import { Text } from '../../../../Components/Text'
import aboutImg from '../../../../images/about.png'

const AboutImg = styled.img`
    width: 100%;
    max-width: 550px;
    height: auto;
    margin-top: -10%;
`

export const About = () => {
  return (
    <Container id="intro" maxWidth="xl">
        <Grid container sx={{ flexDirection: { xs: "column-reverse", md: "row"} }}>
            <Grid xs={12} md={6} className="text-center">
                <AboutImg src={aboutImg} />
            </Grid>
            <Grid xs={12} md={6} className="mt-md-5">
                <Heading>INTRODUCTion</Heading>
                <Text mb="10px" maxWidth="650px">$PRINT is a PulseChain-based revolutionary project that aims to provide people with a profitable opportunity of getting massive accumulated rewards by simply holding $PRINT. Regular trading has its place but keeping the current market situation into consideration, prioritizing holding could be the safest bet.</Text>
                <Text maxWidth="650px">$PRINT does not only ensures stability for the holders but also captivates daily traders through hyper-deflationary tokenomics!    </Text>
            </Grid>
        </Grid>
    </Container>
  )
}
